import { createStore, compose, combineReducers } from 'redux'
import { connectRoutes } from 'redux-first-router'

import prepareMiddleware from './prepareMiddleware'


import reducers from './state/reducers'

const configureStore = (routes, api, createHistory) => {
  const { reducer, middleware, enhancer, thunk } = connectRoutes(
    routes.routes,
    {createHistory}
  ) // notice `thunk`
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const store = createStore(
    reducers({ location: reducer }, { routes, path: window.location.pathname }),
    window.__data,
    composeEnhancers(enhancer, prepareMiddleware(middleware, { api }))
  )

  return store
}

export default configureStore
